import React, { useState } from "react";
import { Box, Divider, Link, Typography } from "@mui/material";
import { PlanoButton, PlanoModal } from "../../Common";
import { LiaFileDownloadSolid } from "react-icons/lia";
import styles from "./PlanogramCard.module.css";
import GuidelinesImage1 from "../../Assets/GuideLines_1.png";
import GuidelinesImage2 from "../../Assets/GuideLines_2.png";
import GuidelinesImage3 from "../../Assets/GuideLines_3.png";
import GuidelinesImage4 from "../../Assets/GuideLines_4.png";

import { useSelector } from "react-redux";
const PlanogramCard = ({ downloadBtn, storeRank }) => {
  const [guidelinesModal, setGuidelinesModal] = useState(false);
  const [downloadNewPlano, setDownloadNewPlano] = useState(false);

  const ifNewVersionDownloadAvailable = useSelector(
    (state) => state.dashboard.newDownloadVersion
  );
  return (
    <Box className={styles.mainDiv}>
      <Box height={"40%"}>
        <Box display={"flex"} justifyContent={"space-between"} p={2}>
          <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24px"}>
            Planogram
          </Typography>

          {ifNewVersionDownloadAvailable ? (
            <Box
              sx={{
                padding: "8px",
                borderRadius: "8px",
                ":hover": { backgroundColor: "white", cursor: "pointer" },
              }}
              onClick={() => {
                setDownloadNewPlano(true);
              }}
            >
              <Typography className={styles.blink_me}>
                Download Latest version
              </Typography>
            </Box>
          ) : (
            <></>
          )}
        </Box>
        <Box className={styles.downloadButtonContainer}>
          <PlanoButton
            extraCss={{
              fontWeight: "800",
              width: "220px",
              height: "36px",
            }}
            mainfunction={() => {
              downloadBtn();
            }}
          >
            <LiaFileDownloadSolid className={styles.downloadButtonIcon} />
            Download{" "}
          </PlanoButton>
        </Box>
        <Divider variant="middle" />
      </Box>
      <Box display={"flex"} justifyContent={"space-between"} p={2}>
        <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24px"}>
          FAQ's
        </Typography>
      </Box>
      <Box mx={2} my={1}>
        <PlanoButton
          extraCss={{ fontWeight: "800", width: "220px", height: "36px" }}
          mainfunction={() => {
            setGuidelinesModal(true);
          }}
        >
          Guidelines
        </PlanoButton>
      </Box>
      <Box display={"flex"} justifyContent={"space-between"} p={2}>
        <Typography fontSize={"20px"} fontWeight={"600"} lineHeight={"24px"}>
          Tutorial
        </Typography>
      </Box>
      <Link
        href="https://www.youtube.com/watch?v=i5ekfrC6GwM"
        underline="hover"
        fontSize={"16px"}
        p={2}
        color={"#f04e23"}
        target="_blank"
      >
        Click here for tutorial
      </Link>

      <PlanoModal
        open={guidelinesModal}
        setOpen={setGuidelinesModal}
        title={"Guideliness"}
        size={"xxl"}
      >
        <Box>
          <img src={GuidelinesImage1} alt="Guidelines 1" width={"100%"} />
          <img src={GuidelinesImage2} alt="Guidelines 2" width={"100%"} />
          <img src={GuidelinesImage3} alt="Guidelines 3" width={"100%"} />
          <img src={GuidelinesImage4} alt="Guidelines 4" width={"100%"} />
        </Box>
      </PlanoModal>

      <PlanoModal
        open={downloadNewPlano}
        setOpen={setDownloadNewPlano}
        title={"Existing Plano Will be overwritten"}
        size={"xs"}
        showFooter={false}
      >
        <Box display={"flex"} gap={14}>
          <PlanoButton
            mainfunction={() => {
              setDownloadNewPlano(false);
            }}
            extraCss={{
              width: "100%",
              backgroundColor: "black",
            }}
          >
            Cancel
          </PlanoButton>
          <PlanoButton
            mainfunction={() => {
              downloadBtn(true);
              setDownloadNewPlano(false);
            }}
            extraCss={{
              width: "100%",
            }}
          >
            Continue
          </PlanoButton>
        </Box>
      </PlanoModal>
    </Box>
  );
};

export default PlanogramCard;
